export default __webpack_public_path__ + "static/media/team-photo-2012.585a4ff1.jpg";